import {useTranslation} from '@aboutyou/i18n';
import {styled} from '@linaria/react';
import React from 'react';
import {Button} from '../../../../atoms/Buttons/Button';

interface BasketFlyoutSuccessButtonsProps {
  onClickPrimaryButton: VoidFunction;
  onClickSecondaryButton: VoidFunction;
  primaryButtonText?: string;
  secondaryButtonText?: string;
}

/**
 * @deprecated This component is deprecated because it violates best practices defined in the @aboutyou/ui-components.
 * Do not take inspiration from this component for new implementations.
 */
export const BasketFlyoutSuccessButtons = ({
  onClickPrimaryButton,
  onClickSecondaryButton,
  primaryButtonText,
  secondaryButtonText,
}: BasketFlyoutSuccessButtonsProps) => {
  const {t} = useTranslation();

  return (
    <ActionsWrapper>
      <Button
        data-testid="continueShoppingButton"
        onClick={onClickPrimaryButton}
        variant="secondary"
      >
        {primaryButtonText || t('Continue shopping')}
      </Button>
      <Button data-testid="goToBasketButton" onClick={onClickSecondaryButton}>
        {secondaryButtonText || t('Go to basket')}
      </Button>
    </ActionsWrapper>
  );
};

const ActionsWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1.25rem;
`;
